import { faClock } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Pill } from '@/components/ui/pill/pill.component';
import { dateFormatter } from '@/utils/formatters/date';

interface AppointmentTodayPillProps {
  date?: string;
}

export function AppointmentTodayPill({ date }: AppointmentTodayPillProps) {
  if (!date || dateFormatter(date, 'date') !== dateFormatter(new Date(), 'date')) {
    return null;
  }

  return (
    <Pill
      variant="info"
      icon={faClock}
      label="Hoje"
      className="font-normal"
      data-testid={DataTestIdEnum.APPOINTMENT_CARD_TODAY_PILL}
    />
  );
}
